import { createSlice } from "@reduxjs/toolkit";
import { getRoles } from "../reduxApi/roleReduxApi";

const roleSlice =createSlice({
    name:'role',
    initialState:{
        status:'idel',
        role:[],
    },
    reducers:{
        // deletePatientAction: (state, action) => {
        //     // Create a new array by filtering out the items to be deleted
        //     state.patient = state.patient.filter((item) => 
        //         !action.payload.includes(item.rowId)
        //     );
        // },
        
        deleteRoleAction:(state,action)=>{
            action.payload.forEach((ROWID) => {
                console.log("ROWIDde",ROWID)
                const index =state.role.findIndex((item)=> item.ROWID === ROWID);
                if(index != -1){
                    state.role.splice(index,1);
                }
            });
        },
        updateroleAction:(state,action) =>{
            console.log("action",action.payload.rowId)
            const index=state.role.findIndex((item)=> item.rowId === action.payload.rowId)
            if(index != -1){
            state.role.splice(index,1,action.payload)
            }
        },
        addroleAction: (state, action) => {
            console.log("Adding safety data:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.role.unshift(temp);
           
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRoles.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getRoles.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing role Data", action.payload)
                state.role = action.payload.data.response
;
            })
    }
})
export const {deleteRoleAction ,updateroleAction,addroleAction}=roleSlice.actions
export default roleSlice.reducer